import { http } from "msw";
import type { Order, OrderStatus, Page } from "../../api/types";
import { getCollection } from "../db";
import { paginateCursor, sortBy } from "../engine";
import { decorateCreatorSummary, decorateProductSummary, findViewerStoreSlug, mockJson } from "./shared";

export const ordersHandlers = [
  http.get("/api/orders", async ({ request }) => {
    const url = new URL(request.url);
    const status = url.searchParams.get("status") as OrderStatus | null;
    const q = url.searchParams.get("q")?.trim().toLowerCase();
    const cursor = url.searchParams.get("cursor");
    const limit = Number(url.searchParams.get("limit") ?? 50) || 50;

    const storeSlug = await findViewerStoreSlug();
    const allOrders = await getCollection<Order>("orders");
    let mine = allOrders.filter((o) => o.storeSlug === storeSlug);
    if (status) mine = mine.filter((o) => o.status === status);
    if (q) mine = mine.filter((o) => `${o.number} ${o.buyer.username}`.toLowerCase().includes(q));
    mine = sortBy(mine, (o) => -Date.parse(o.createdAt));

    const page = paginateCursor(mine, cursor, limit);
    const body: Page<Order> = {
      items: page.items.map((order) => ({
        ...order,
        buyer: decorateCreatorSummary(order.buyer),
        product: decorateProductSummary(order.product),
      })),
      nextCursor: page.nextCursor,
    };
    return mockJson(body);
  }),
];
